import React from 'react';

interface FormContainerProps {
  children: React.ReactNode;
  className?: string;
}

export const FormContainer: React.FC<FormContainerProps> = ({ 
  children, 
  className = 'p-2' 
}) => {
  return (
    <form 
      className={className}
      autoComplete="on"
      method="post"
      action="#"
      onSubmit={(e) => e.preventDefault()}
    >
      {children}
    </form>
  );
};